"use client";

import Script from "next/script";

/**
 * Loads Truemed's merchant PDP widget script.
 * Uses a fixed `id` so Next.js dedupes it even if this mounts from multiple places on a page.
 */
export default function TruemedScript() {
  return (
    <Script
      id="truemed-merchant-pdp-widget"
      src="https://static.truemed.com/widgets/merchant-pdp-widget.min.js"
      strategy="afterInteractive"
    />
  );
}
